import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const DatePickerInput = ({
  name,
  onChange,
  minDate = null,
  maxDate = null,
  defaultValue = null,
}) => {
  const [startDate, setStartDate] = useState(defaultValue);

  useEffect(() => {
    setStartDate(defaultValue)
  },[defaultValue])

  const CustomInput = React.forwardRef(({ value, onClick }, ref) => (
    <div
      className="d-flex justify-content-between align-items-center p-2 px-3 fs-6 bg-transparent border card-border rounded custom-placeholder w-100"
      onClick={onClick}
    >
      <span>{value || "Select date"}</span>
      <div className="cursor-pointer">
        <img
          src={`/images/vectors/calendar-gray.svg`}
          alt="Calendar Icon"
          style={{ width: "18px" }}
        />
      </div>
    </div>
  ));

  const handleDateChange = (date) => {
    setStartDate(date);
    if (onChange) onChange(date);
  };

  return (
    <div className="d-flex flex-column w-100">
      <DatePicker
        name={name}
        selected={startDate}
        onChange={handleDateChange}
        dateFormat="dd/MM/yyyy"
        minDate={minDate}
        maxDate={maxDate}
        showMonthDropdown
        showYearDropdown
        scrollableMonthDropdown
        scrollableYearDropdown
        yearDropdownItemNumber={80}
        customInput={<CustomInput />}
      />
    </div>
  );
};

export default DatePickerInput;
